"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChangePasswordDialog = exports.ChangePasswordDialogDefaultProps = exports.PASSWORD_CHANGE_TICKET_QUERY = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var dialog_title_1 = require("./dialog-title");
var person_photo_1 = require("../entities/person-photo");
var use_lang_1 = require("../../hooks/use-lang");
var use_active_user_1 = require("../../hooks/use-active-user");
var sprintf_js_1 = require("sprintf-js");
var html_1 = require("./html");
var dialog_1 = require("./dialog");
var icon_button_1 = require("./icon-button");
var terms_content_scroll_view_1 = require("../entities/terms-content-scroll-view");
var client_1 = require("@apollo/client");
var loader_1 = require("./loader");
var client_2 = require("@apollo/client");
// -------- Queries -------->
exports.PASSWORD_CHANGE_TICKET_QUERY = (0, client_2.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query PasswordChangeTicket($id: String!) {\n    passwordChangeTicket(id: $id)\n  }\n"], ["\n  query PasswordChangeTicket($id: String!) {\n    passwordChangeTicket(id: $id)\n  }\n"])));
exports.ChangePasswordDialogDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    background: ", ";\n    box-shadow: 0px 2px 5px -3px rgba(0, 0, 0, 0.6); \n    font-size: ", ";\n    width: 90%;\n    max-width: 720px;\n  "], ["\n    background: ", ";\n    box-shadow: 0px 2px 5px -3px rgba(0, 0, 0, 0.6); \n    font-size: ", ";\n    width: 90%;\n    max-width: 720px;\n  "])), theme_1.theme.COLOR('app-chrome'), theme_1.theme.FONT_SIZE(15))
});
var BodyStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    text-align: left;\n  "], ["\n    text-align: left;\n  "])))
});
var IntroStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n    background: ", ";\n    padding: ", " ", ";\n    padding-top: ", ";\n  "], ["\n    display: flex;\n    align-items: center;\n    background: ", ";\n    padding: ", " ", ";\n    padding-top: ", ";\n  "])), theme_1.theme.COLOR('app-chrome'), theme_1.theme.UNIT(4), theme_1.theme.UNIT(5), theme_1.theme.UNIT(1))
});
var PhotoStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    margin-right: ", ";\n  "], ["\n    margin-right: ", ";\n  "])), theme_1.theme.UNIT(5))
});
var TitleStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var ContentStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    margin: 0;\n    line-height: 1.75em;\n    color: ", ";\n  "], ["\n    margin: 0;\n    line-height: 1.75em;\n    color: ", ";\n  "])), theme_1.theme.COLOR('text'))
});
var ControlsStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    background: ", ";\n    border-top: 1px solid ", ";\n    padding: ", " ", " ", ";\n  "], ["\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    background: ", ";\n    border-top: 1px solid ", ";\n    padding: ", " ", " ", ";\n  "])), theme_1.theme.COLOR('app-chrome'), theme_1.theme.COLOR('line-mid'), theme_1.theme.UNIT(6), theme_1.theme.UNIT(5), theme_1.theme.UNIT(6.2))
});
var ContinueButtonStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var TermsStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    height: 700px;\n    max-height: 44vh;\n    border-top: 1px solid ", ";\n  "], ["\n    height: 700px;\n    max-height: 44vh;\n    border-top: 1px solid ", ";\n  "])), theme_1.theme.COLOR('line-mid'))
});
var UrlLoaderStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  "], ["\n  "])))
});
// -------- Components -------->
var My = {
  Container: (0, styled_components_1.default)(dialog_1.Dialog)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Title: (0, styled_components_1.default)(dialog_title_1.DialogTitle)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), TitleStyles),
  UrlLoader: (0, styled_components_1.default)(loader_1.Loader)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), UrlLoaderStyles),
  Body: styled_components_1.default.div(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Intro: styled_components_1.default.header(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), IntroStyles),
  Photo: (0, styled_components_1.default)(person_photo_1.PersonPhoto)(templateObject_17 || (templateObject_17 = __makeTemplateObject(["", ""], ["", ""])), PhotoStyles),
  Content: styled_components_1.default.p(templateObject_18 || (templateObject_18 = __makeTemplateObject(["", ""], ["", ""])), ContentStyles),
  Terms: (0, styled_components_1.default)(terms_content_scroll_view_1.TermsContentScrollView)(templateObject_19 || (templateObject_19 = __makeTemplateObject(["", ""], ["", ""])), TermsStyles),
  Controls: styled_components_1.default.div(templateObject_20 || (templateObject_20 = __makeTemplateObject(["", ""], ["", ""])), ControlsStyles),
  ContinueButton: (0, styled_components_1.default)(icon_button_1.NextIconButton)(templateObject_21 || (templateObject_21 = __makeTemplateObject(["", ""], ["", ""])), ContinueButtonStyles)
};
var ChangePasswordDialog = function (props) {
  var className = props.className;
  var profile = (0, use_active_user_1.useActiveUser)();
  var id = profile.id;
  var t = (0, use_lang_1.useLang)();
  var givenName = profile.givenName;
  var _a = (0, client_1.useQuery)(exports.PASSWORD_CHANGE_TICKET_QUERY, {
      variables: {
        id: id
      }
    }),
    loading = _a.loading,
    _b = _a.data,
    data = _b === void 0 ? {
      passwordChangeTicket: ''
    } : _b;
  var passwordChangeTicket = data.passwordChangeTicket;
  var person = {
    id: profile.id,
    name: profile.name,
    slug: profile.slug,
    photo: profile.picture && {
      id: profile.picture,
      url: profile.picture
    }
  };
  // TODO - move this to an external template?
  var introTemplate = t("To keep your data safe and our platform secure, you now need to change your password.");
  var introText = (0, sprintf_js_1.sprintf)(introTemplate, givenName);
  var continueLabel = t('Continue');
  var continueIsDisabled = loading;
  return react_1.default.createElement(My.Container, {
    title: t('Change Password'),
    padBody: false,
    controls: react_1.default.createElement(My.Controls, null, loading ? react_1.default.createElement(My.UrlLoader, {
      spinnerSize: 18
    }) : react_1.default.createElement("div", null), react_1.default.createElement(My.ContinueButton, {
      forceAnchorTag: true,
      to: passwordChangeTicket,
      disabled: continueIsDisabled
    }, continueLabel)),
    className: className
  }, react_1.default.createElement(My.Body, null, react_1.default.createElement(My.Intro, null, react_1.default.createElement(My.Photo, {
    size: 64,
    entity: person
  }), react_1.default.createElement(My.Content, null, react_1.default.createElement(html_1.HTML, {
    text: introText
  })))));
};
exports.ChangePasswordDialog = ChangePasswordDialog;
exports.ChangePasswordDialog.defaultProps = exports.ChangePasswordDialogDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21;